import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

const initialState = {};

const dismissSlice = createSlice({
  name: "dismiss",
  initialState,
  reducers: {
    setDismiss(state, action) {
      state.dismiss = action.payload;
    }
  }
});

const { actions, reducer } = dismissSlice;

export const { setDismiss } = actions;

export const setDismissAction = (data) => async (dispatch) => {
  dispatch(setDismiss(data));
};

export default reducer;
